import WrappedPasswordFinderMobileForm from './views/PasswordFinderMobileView';

export default WrappedPasswordFinderMobileForm;